import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {NavIconChevronRightIcon} from 'shells/icon/navigation/nav-icon-chevron-right';
import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';

import {FeatureGrid} from '../../ai-home/features/feature-grid';
import {EXPLORE_PAGE_FEATURES} from '../../ai-home/features/features-list';

import {ExplorePageSectionHeader} from './explore-page-section-header';

export function NutshellAiSection() {
    const features = EXPLORE_PAGE_FEATURES;

    return (
        <Stack spacing={16}>
            <Stack
                isHorizontal={true}
                spacing={16}
                justifyContent='space-between'
                alignItems='center'
            >
                <ExplorePageSectionHeader title='Nutshell AI' />
                {/* @ts-expect-error */}
                <Link as={RoutedLink} variant='ai' to='/ai/home'>
                    <div className='flex align-center gap-8'>
                        See all features
                        <div className='mt-2'>
                            <NavIconChevronRightIcon size={12} wrapWithDiv={false} />
                        </div>
                    </div>
                </Link>
            </Stack>
            <FeatureGrid features={features} />
        </Stack>
    );
}
